import ApiClient from '@/libs/http-client'

const WikiService = {
    endpoints(route, param) {
        const url = {
            getActiveUsers: '/api/users?active=1&roles[]=user&roles[]=HR',
            changeDateOfBirth: `/api/users/${param}`,
            changePassword: '/api/users/password/reset',
            updateProfileData: '/api/users',
            editProfileData: `/api/users/${param}`,
            getAllUsers: '/api/users?roles[]=user&roles[]=HR',
            wiki: 'api/wiki-pages',
            deletePost: `api/wiki-pages/${param}` ,
        }
        return url[route]
    },
    get(url, param = {}) {
        return ApiClient.get(this.endpoints(url, param));
    },
    put(url, params = {}, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config);
    },
    post(url, params = {}, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config);
    },
    patch(url, params = {}, data, config = {}) {
        return ApiClient.patch(this.endpoints(url, params), data, config);
    },
    delete(url, params = {}, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config);
    },
    postFile(url, params = {}, data, config = {}) {
        config = {
            headers: {
                "Accept": "application/json",
                "Content-Type": "multipart/form-data",
            },
            ...config
        }
        return ApiClient.post(this.endpoints(url, params), data, config);
    },

    getWiki(config) {
        return ApiClient.get('api/wiki-pages', config)
    },

    getWikiCategories(config) {
        return ApiClient.get('api/wiki-categories', config)
    },

    createWikiCategory(data, config) {
        return ApiClient.post('api/wiki-categories', data, config)
    },

    updateWikiCategory(id, data, config) {
        return ApiClient.put(`api/wiki-categories/${id}`, data, config)
    },

    deleteWikiCategory(id, config) {
        return ApiClient.delete(`api/wiki-categories/${id}`, config)
    },

    updateTopic(id, data, config) {
        return ApiClient.put(`/api/wiki-pages/${id}`, data, config)
    },

    delNotification(id) {
        this.delLoading = id
        this.$store.dispatch('notifications/deleteNotification', id)
            .then(() => {
                    this.$store.dispatch('notifications/getAllNotifications').then(() => {
                        this.delLoading = false
                        this.allNotifications = this.getAllNotifications
                    })
                }
            )
    },

    getUsers(config) {
        return ApiClient.get('/api/users?active=1&roles[]=user&roles[]=HR', config)
    },
    changeDateOfBirth(id, data, config) {
        return ApiClient.put(`/api/users/${id}`, data, config)
    },
    changeNotOwnUserData(id, data, config) {
        return ApiClient.put(`/api/users/${id}`, data, config)
    },
    addNewUser( data, config) {
    return ApiClient.put(`/api/users/`, data, config)
  },
    addNewPost( data, config) {
        return ApiClient.put(`/api/wiki-pages/`, data, config)
    },
    getUserClients(id, config) {
        return ApiClient.get(`/api/users?role_id=2&author_id=${id}`, config)
    },
    getUserRoles(config) {
        return ApiClient.get('/api/roles', config)
    },
    getUserPositions(config) {
        return ApiClient.get('/api/positions', config)
    },
    getCurrentEmployees(config) {
        return ApiClient.get('/api/users', config)
    }
}

export default WikiService
